import timeZones from 'moment-timezone/data/meta/latest.json';

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const { zones } = timeZones;

/**
 * Gets country code for the user agent by using Intl.DateTimeFormat()
 */
export const getUserCountryCode = (): string | null => {
    if (!userTimeZone) {
        return null;
    }
    const zone = zones[userTimeZone];
    if (!zone) {
        return null;
    }

    const countries = zone['countries'] ?? null;
    if (!countries || !Array.isArray(countries) || countries.length === 0) {
        return null;
    }

    return countries[0];
};
